export default __webpack_public_path__ + "static/media/login_hero.e4af68e8.png";